import { Icon, type IconGlyphProps } from 'BomdisoftComponents/icons/base';
import { ARROW_DOWNWARD_ROUNDED_GLYPH } from 'BomdisoftComponents/icons/glyphs';

export const ArrowDownwardRoundedIcon = (props: IconGlyphProps) => <Icon {...props} glyph={ARROW_DOWNWARD_ROUNDED_GLYPH} />;
